import React, { useState } from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { DETAIL_ACTIONS } from "../../../../../../constants/Define";
import { useTranslation } from "react-i18next";
import Input from "../../../../common/component/Input";

const defaultCollapseKey = "searchInfoConfigSection";

function SearchInfoConfigSection(props) {
  const { campaign, action, onChangeMaxMin } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.searchInfoConfig")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              messageBelowInput={true}
              labelTitle={t("item.campaign.searchInfoConfigs.roomCount")}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Wrapper className="row">
                <Wrapper className="col-md-6">
                  <Input
                    type="text"
                    autoComplete="off"
                    placeholder={"ABC"}
                    className="form-control text-right"
                    name="hotel.minRoomNumber"
                    onChange={e =>
                      onChangeMaxMin(
                        "minRoomNumber",
                        e.target.value,
                        "maxRoomNumber"
                      )
                    }
                    value={campaign.minRoomNumber ? campaign.minRoomNumber : ""}
                  />
                </Wrapper>
                <Wrapper className="col-md-6">
                  <Input
                    type="text"
                    autoComplete="off"
                    placeholder={t("item.campaign.searchInfoConfigs.max")}
                    className="form-control text-right"
                    name="hotel.maxRoomNumber"
                    onChange={e =>
                      onChangeMaxMin(
                        "maxRoomNumber",
                        e.target.value,
                        "minRoomNumber",
                        false
                      )
                    }
                    value={campaign.maxRoomNumber ? campaign.maxRoomNumber : ""}
                  />
                </Wrapper>
              </Wrapper>
            </FormWrapperInputComponent>
            <FormWrapperInputComponent
              messageBelowInput={true}
              labelTitle={t("item.campaign.searchInfoConfigs.nightCount")}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Wrapper className="row">
                <Wrapper className="col-md-6">
                  <Input
                    type="text"
                    autoComplete="off"
                    placeholder={t("item.campaign.searchInfoConfigs.min")}
                    className="form-control text-right"
                    name="hotel.minLenghOfStay"
                    onChange={e =>
                      onChangeMaxMin(
                        "minLenghOfStay",
                        e.target.value,
                        "maxLenghOfStay"
                      )
                    }
                    value={
                      campaign.minLenghOfStay ? campaign.minLenghOfStay : ""
                    }
                  />
                </Wrapper>
                <Wrapper className="col-md-6">
                  <Input
                    type="text"
                    autoComplete="off"
                    placeholder={t("item.campaign.searchInfoConfigs.max")}
                    className="form-control text-right"
                    name="hotel.maxLenghOfStay"
                    onChange={e =>
                      onChangeMaxMin(
                        "maxLenghOfStay",
                        e.target.value,
                        "minLenghOfStay",
                        false
                      )
                    }
                    value={
                      campaign.maxLenghOfStay ? campaign.maxLenghOfStay : ""
                    }
                  />
                </Wrapper>
              </Wrapper>
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

SearchInfoConfigSection.propTypes = {
  campaign: PropTypes.object,
  action: PropTypes.string,
  onChangeMaxMin: PropTypes.func
};

SearchInfoConfigSection.defaultProps = {
  campaign: {},
  action: "",
  onChangeMaxMin: () => {}
};

export default SearchInfoConfigSection;
